"use client";
import type { AuthenticatedProperties } from "./true-blue/authenticated";
import { Authenticated } from "./true-blue/authenticated";
import { AuthLoadingSkeleton } from "./true-blue/auth-loading-skeleton";
import type { UnauthenticatedProperties } from "./true-blue/unauthenticated";
import { Unauthenticated } from "./true-blue/unauthenticated";
import { useDotcomAuth } from "@jetblue/dotcom-auth";

export type HeaderTrueBlueProperties = {
  creditProfileMenu: AuthenticatedProperties["creditProfileMenu"];
  loggedInMenu: AuthenticatedProperties["loggedInMenu"];
  loggedOutMenu: UnauthenticatedProperties;
};
export const HeaderTrueBlue = ({
  creditProfileMenu,
  loggedInMenu,
  loggedOutMenu,
}: HeaderTrueBlueProperties) => {
  const { customerDetails, handleLogin, handleLogout, status } =
    useDotcomAuth();
  if (status === "authenticated" && customerDetails) {
    return (
      <Authenticated
        creditProfileMenu={creditProfileMenu}
        customerDetails={customerDetails}
        handleLogout={handleLogout}
        loggedInMenu={loggedInMenu}
      />
    );
  }

  if (status === "authenticating" || status === "signingOut") {
    return <AuthLoadingSkeleton />;
  }

  return <Unauthenticated {...loggedOutMenu} handleLogin={handleLogin} />;
};

HeaderTrueBlue.displayName = "Header.TrueBlue";
